"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeSessionStorageItem = exports.getSessionStorageItem = exports.setSessionStorageItem = exports.querystringToObj = exports.isInPopup = exports.isInIframe = exports.isBrowser = void 0;
const isBrowser = () => typeof window !== "undefined";
exports.isBrowser = isBrowser;
const isInIframe = () => {
    if (!(0, exports.isBrowser)())
        return false;
    try {
        return window.self !== window.top;
    }
    catch (e) {
        return true;
    }
};
exports.isInIframe = isInIframe;
const isInPopup = () => {
    return (0, exports.isBrowser)() && !!window.opener;
};
exports.isInPopup = isInPopup;
const querystringToObj = (query) => {
    var _a, _b;
    let search = (_b = query !== null && query !== void 0 ? query : (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.search) !== null && _b !== void 0 ? _b : "";
    let params = new URLSearchParams(search);
    let obj = {};
    for (const [key, val] of params) {
        obj[key] = val;
        try {
            // Check to see if the value looks like a URL so we can find search params on it
            if (val.startsWith("https://") ||
                val.startsWith("http://") ||
                val.startsWith("/") ||
                val.startsWith("?")) {
                let nestedQueryObj = (0, exports.querystringToObj)(new URL(val, "https://fake.example").search);
                // merge and give priority to values already on the obj
                obj = Object.assign(Object.assign({}, nestedQueryObj), obj);
            }
        }
        catch (e) {
            // not a url, just a regular key/value pair
            continue;
        }
    }
    return obj;
};
exports.querystringToObj = querystringToObj;
const setSessionStorageItem = (key, value) => {
    if (typeof window !== 'undefined') {
        try {
            window.sessionStorage.setItem(key, value);
        }
        catch (error) {
            console.warn('Warning: Failed to set sessionStorage item:', error);
        }
    }
    else {
        console.warn('Warning: window object is not defined.');
    }
};
exports.setSessionStorageItem = setSessionStorageItem;
const getSessionStorageItem = (key, defaultValue = "") => {
    if (typeof window !== 'undefined') {
        try {
            return window.sessionStorage.getItem(key) || defaultValue;
        }
        catch (error) {
            console.warn('Warning: Failed to get sessionStorage item:', error);
            return defaultValue;
        }
    }
    else {
        return defaultValue;
    }
};
exports.getSessionStorageItem = getSessionStorageItem;
const removeSessionStorageItem = (key) => {
    if (typeof window !== 'undefined') {
        try {
            window.sessionStorage.removeItem(key);
        }
        catch (error) {
            console.warn('Warning: Failed to remove sessionStorage item:', error);
        }
    }
    else {
        console.warn('Warning: window object is not defined.');
    }
};
exports.removeSessionStorageItem = removeSessionStorageItem;
